import React, { useRef, useContext } from 'react'
import { useHistory } from 'react-router-dom'

import useMountedMfe from 'src/hooks/useMountedMfe'
import { reverse } from 'src/routes/config'
import PageHeader from 'src/components/PageHeader'
import GoBackArrow from 'src/components/GoBackArrow'
import { PageHeaderContext } from 'src/components/PageHeader/pageHeaderContext'

const portalId = 'page-header-bell-portal'

function NotificationsMfe({ mode, portal = null }) {
    const pageRef = useRef(null)
    const portalRef = useRef(portal)
    const { title } = useContext(PageHeaderContext)
    const history = useHistory()
    const mountRef = mode === 'drawer' ? portalRef : pageRef

    useMountedMfe(
        'mfe-notifications',
        reverse('notifications'),
        mountRef.current,
        {
            mode,
        }
    )

    if (mode === 'drawer') {
        return null
    }

    return (
        <>
            <PageHeader
                preContent={
                    title?.goBack ? (
                        <GoBackArrow
                            history={history}
                            onClickCallback={
                                title.goBackLinkProps?.onClickCallback ??
                                (() => {})
                            }
                        />
                    ) : null
                }
            />
            <div ref={pageRef} />
        </>
    )
}

// For the Drawer, we have to be certain that the portal div is actually available. As the Header is inside of a Suspense, we delay this load until the portal is found.
const LazyNotificationsMfe = React.lazy(props => {
    return new Promise(resolve => {
        const intervalRef = setInterval(() => {
            const portal = document.getElementById(portalId)
            if (portal) {
                clearInterval(intervalRef)
                resolve({
                    default: function NotificationsMfeWithPortal(props) {
                        return <NotificationsMfe {...props} portal={portal} />
                    },
                })
            }
        }, 250)
    })
})

export default function NotificationsMfeWrapper(props) {
    const { mode } = props
    const Component =
        mode === 'drawer' ? LazyNotificationsMfe : NotificationsMfe
    return <Component {...props} />
}
